"use strict";
import * as Sentry from "@sentry/vue";

const loadThirdPartyContentRules = async () => {
  return fetch(import.meta.env.VITE_THIRD_PARTY_CONTENT_RULES_URL, { method: "GET" }).then((response) => response.json());
};

const registerRules = (rules) => {
  if (typeof globalThis.wasmM === "undefined") {
    throw new Error("This function requires the wasm module to be available globally");
  }
  const wasmM = globalThis.wasmM;

  if (rules["whitelist"]) {
    for (const domain in rules["whitelist"]) {
      const domainEntries = rules["whitelist"][domain];
      for (const { type, pattern, company_id } of domainEntries) {
        if (!wasmM.registerWhitelistedDomain(domain, wasmM.WhitelistType.values[parseInt(type)], pattern ? pattern : "", company_id ? company_id : -1)) {
          Sentry.captureException(new Error(`Fail to register whitelist entry {${domain}, ${type}, ${pattern}, ${company_id}`));
        }
      }
    }
  }
  if (rules["blacklist"]) {
    for (const url in rules["blacklist"]) {
      const { type, company_id } = rules["blacklist"][url];
      if (!wasmM.registerBlacklistedUrl(url, wasmM.BlacklistType.values[parseInt(type)], company_id)) {
        Sentry.captureException(new Error(`Fail to register blacklist entry {${url}, ${type}, ${company_id}`));
      }
    }
  }
  return true;
};

export { loadThirdPartyContentRules, registerRules };
